import useDiscard from "../../../useDiscard";
import useWeakMap from "../../../utils/useWeakMap"

const store = useWeakMap();

const onDiscardLayer = layer => store.delete(layer);

const useStrictPropKey = (layer) => {
    if (!store.has(layer)) {
        store.set(layer, new Set());
        useDiscard(layer, onDiscardLayer);
    }
    for (let key in layer) {
        store.get(layer).add(key);
    }
}

export const isPropKeyValid = (layer, key) => {
    if (!store.has(layer)) {
        console.warn('layer undefined');
    }
    return store.get(layer).has(key);
}

export default useStrictPropKey;